import f from '@/application/shared/functions'
const ct = require("countries-and-timezones");
var ids = {
    web : '88690552124-olo5h25u9ps52b7j22gs30d1arrvqrna.apps.googleusercontent.com',
    ios : '88690552124-eh2oen7066ccsl9itsg306vt1dfo6mjq.apps.googleusercontent.com',
    android : '88690552124-atbb7djo2n4e4luheibgonrak0lb5vl5.apps.googleusercontent.com'
}

var Cwgapi = function(){
    var self = this
    var clientid = null

    var data = null

    self.auth2 = {
        init : function(p){

            clientid = p.client_id

            return Promise.resolve()

        },

        getAuthInstance : function(){
            return self
        },

        
    }

    self.currentUser = {
        get : function(){

            if(!data) return null


            var _data = {

                type : 'static',

                tt : {
                    sV : data.givenName,
                    vT : data.familyName,
                    gK : data.imageUrl,

                },

                wc : {
                    access_token : data.accessToken,
                    idToken : ''
                }

            }

            return _data
        }
    }

    self.clearWh = function(){
        data = null;
    }

    self.load = function(fakeid, clbk){
        if(clbk) clbk()
    }

    return self
}

var Authways = function(core){
    var self = this;

    var user = core.user

    var getpl = function(){
        if(window.cordova && f.isios()) return 'ios'
        if(window.cordova) return 'android'
        
        return 'web'

    }

    self.init = function(){


        return new Promise((resolve, reject) => {

            f.retry(function () {

                return window.cordova || (typeof google == 'undefined' ? false : google.accounts)

            }, function () {

                if (window.cordova){

                    window.google = {}

                    var wgapi = new Cwgapi();

                    return wgapi.auth2.init({

                        client_id: ids[getpl()]

                    }).then(r => {

                        window.google.auth = wgapi.auth2.getAuthInstance()

                        resolve()     

                    }).catch(e => {
                        console.error(e)
                    })
                }

                if(typeof google != 'undefined' && google.accounts){

                    google.accounts.id.initialize({
                        client_id: ids[getpl()],
                        callback: handleCredentialResponseGoogle
                    });

                    return Promise.resolve()
                    
                }
    
                else{
                    resolve(null)
                }
    
            }, 5)


            

        })
       
    }

    var handleCredentialResponseGoogle = function(CredentialResponse){
        var data = f.decodeJwtResponse(CredentialResponse.credential)
            data.jwt = CredentialResponse.credential


        return self.data.googlejwt(data).then((profile) => {


            return self.link(profile).then(() => {

                core.vm.$router.push('/')

                return Promise.resolve()

            })
            
        })
        


        .catch(e => {
            console.error(e)
        })
    }

    self.data = {
        apple : function(data){

            console.log("DATA2", data)

            var nmc = data.fullName || data.name || {}


            var _data = {
                email : data.email,
                firstname : nmc.givenName || nmc.firstName || '',
                lastname : nmc.familyName || nmc.lastName || '',
                image : '',
                accessToken : data.authorizationCode || data.code,
                idToken :  data.identityToken || data.id_token,
                type : 'apple'
            }

            return Promise.resolve(_data)

        },
        googlejwt : function(data){

            var _data = {
                email : data.email,
                firstname : data.given_name,
                lastname : data.family_name,
                image : data.picture,
                type : 'google',
                jwt : data.jwt,
                audience : ids[getpl()]
            }

            return Promise.resolve(_data)
        },

        googlefirebase : function({credential, user, audience}){

             var _data = {
                email : user.email,
                firstname : user.name,
                lastname : '',
                image : user.photoUrl,
                type : 'google',
                jwt : credential.idToken,
                audience
            }

            return Promise.resolve(_data)

        },

        
        google : function(){
            var gdata = window.google.auth.currentUser.get()


            if (gdata.type != 'static'){

                let authresponse = gdata.getAuthResponse()
                let profile = gdata.getBasicProfile()
    

                if(!gdata || !profile || !authresponse) return Promise.reject('emptyData')

                var data = {
                    //email : gdata.rt.$t,
                    firstname : profile.getGivenName(),
                    lastname : profile.getFamilyName(),
                    image : profile.getImageUrl(),

                    accessToken : authresponse.access_token,
                    idToken :  authresponse.id_token,
                    type : 'google'
                }
            }
            else{

                var data = {
                    //email : gdata.rt.$t,
                    firstname : gdata.tt.sV,
                    lastname : gdata.tt.familyName,
                    image : gdata.tt.gK,

                    accessToken : gdata.wc.access_token,
                    idToken :  gdata.wc.idToken,
                    type : 'google'
                }


            }


            

            return Promise.resolve(data)
        }
    }


    self.link = function(payload){

        payload.info = {
            type : 0,
            timezone : user.timeZoneOffset, 
            locale : user.locale
        }

        var tzc = ct.getCountryForTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
        
        if (tzc && tzc.id){
            payload.info.countrycode = tzc.id.toLowerCase()
        }

        return user.link(payload)
    }

    self.signin = {
        appleweb : function(){
            if(typeof AppleID == 'undefined'){
                return Promise.reject('SignInWithApple none')
            }

            return AppleID.auth.signIn({
                usePopup : true
            }).then((data) => {

                console.log("DATA", data)

                var _data = {
                    ...data.authorization,
                    ...data.user
                }

                return self.signin.appleWebContinue(_data)
            })

        },

        appleWebContinue : function(data){

            var profile = {}

            return self.data.apple(data).then(_data => {
                profile.data = _data

                return Promise.resolve()
            }).then(() => {

                return self.link(profile.data)

            }).then((d) => {

                core.vm.$router.push('/')

                return resolve(d)

            }).catch(e => {

                return reject(e)

            })

        },
        apple : function(){

            return new Promise((resolve, reject) => {

                var profile = {}

                if(!window.cordova.plugins.SignInWithApple){
                    return reject('SignInWithApple none')
                }

                window.cordova.plugins.SignInWithApple.signin(

                    { requestedScopes: [0, 1] },

                    function(data){


                        self.data.apple(data).then(_data => {
                            profile.data = _data

                            return Promise.resolve()
                        }).then(() => {

                            return self.link(profile.data)
            
                        }).then((d) => {

                            core.vm.$router.push('/')

                            return resolve(d)

                        }).catch(e => {
            
                            return reject(e)
            
                        })

                    },

                    function(err){
                        
                        reject(err)
                    }
                )

            })
        },
        google : function(){

            var profile = {}

            if(window.google.auth && google.auth && window.cordova){

                var audience = ids[getpl()] //'88690552124-atbb7djo2n4e4luheibgonrak0lb5vl5.apps.googleusercontent.com'
                
                return new Promise((resolve, reject) => {

                    FirebasePlugin.authenticateUserWithGoogle(
                        audience,
                        function (credential) {

                            FirebasePlugin.signInWithCredential(
                                credential,
                                function (data) {

                                    FirebasePlugin.getCurrentUser(
                                        function (user) {

                                            resolve({
                                                user : user,
                                                credential
                                            })

                                            
                                        },
                                        function (error) {
                                            reject(error)
                                        }
                                    );

                                },
                                function (error) {
                                    reject(error)
                                }
                            );
                        },
                        function (error) {
                            reject(error)
                        }
                    )

                }).then(({credential, user}) => {


                    profile.auth = {credential, user, audience}

                    return self.data.googlefirebase(profile.auth)

                }).then(r => {

                    profile.data = r

                    return Promise.resolve()

                }).then(() => {
                    return self.link(profile.data).then(() => {
                        core.vm.$router.push('/')
                    })

                }).catch(e => {

                    console.error(e)

                    return Promise.reject(e)

                })
            }

            else{

                return new Promise((resolve, reject) => {
                    google.accounts.id.prompt((notification) => {

                        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
                            return reject('continue with another identity provider')
                        }

                        resolve()
                        
                    })
                })
                
            }

            
        }
    }

    return self;
}

export default Authways